<div
  class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-space-between"
>
  <h5 class="mb-0 d-flex align-items-center">
    <button mat-icon-button (click)="goBack()">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <span>Profissional</span>
  </h5>
  <ol class="breadcrumb mb-0 ps-0">
    <li class="breadcrumb-item">
      <a routerLink="/">
        <i class="ri-home-8-line"></i>
        Dashboard
      </a>
    </li>
    <li class="breadcrumb-item gray-color">Profissional</li>
    <li class="breadcrumb-item fw-semibold">Editar</li>
  </ol>
</div>

<mat-card class="mb-25 tagus-card">
  <mat-card-header class="health-edit-header">
    <div class="health-edit-header__content">
      <div class="health-edit-header__left">
        <div class="health-edit-header__icon">
          <i class="ri-stethoscope-line"></i>
        </div>
        <div class="health-edit-header__meta p-5">
          <h5 class="mb-0">Editar profissional</h5>
          <p class="mb-0">
            <span class="name">{{
              professionalData?.fullname || "Carregando..."
            }}</span>
            <span class="sep" *ngIf="professionalData?.updatedAt">•</span>
            <span class="updated" *ngIf="professionalData?.updatedAt">
              Atualizado em
              {{ professionalData?.updatedAt | date: "dd/MM/yyyy HH:mm" }}
            </span>
          </p>
        </div>
      </div>

      <div class="health-edit-header__right">
        <mat-chip class="chip chip-type" disableRipple>
          <i class="ri-id-card-line"></i>
          {{ professionalTypeLabel }}
        </mat-chip>
        <mat-chip class="chip chip-docs" disableRipple>
          <i class="ri-file-list-3-line"></i>
          Docs {{ documentsApproved }}/{{ documentsTotal }}
        </mat-chip>
      </div>
    </div>
  </mat-card-header>
  <mat-card-content>
    <mat-tab-group>
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="mr-1">badge</mat-icon>
          Dados Pessoais
        </ng-template>
        <br />
        <div fxFlex="100%" class="row">
          <form
            [formGroup]="professionalForm"
            (submit)="onProfessionalSubmit()"
          >
            <div class="row">
              <div class="col-lg-4 col-md-6 col-sm-12">
                <div class="tagus-form-group">
                  <label class="d-block mb-12 fw-semibold gray-color"
                    >Nome completo <span>*</span></label
                  >
                  <mat-form-field>
                    <i class="ri-user-3-line"></i>
                    <mat-label>Insira o nome</mat-label>
                    <input
                      matInput
                      type="text"
                      formControlName="fullname"
                      id="fullname"
                      style="text-transform: uppercase"
                    />
                    <button mat-icon-button matSuffix type="button" (click)="copyToClipboard(professionalForm.get('fullname')?.value, 'Nome completo')">
                      <mat-icon>content_copy</mat-icon>
                    </button>
                    <mat-error
                      *ngIf="hasErrorProfessional('fullname', 'required')"
                      >O nome é obrigatório</mat-error
                    >
                    <mat-error
                      *ngIf="hasErrorProfessional('fullname', 'minlength')"
                      >O nome deve ter no mínimo 3 caracteres</mat-error
                    >
                    <mat-error
                      *ngIf="hasErrorProfessional('fullname', 'maxlength')"
                      >O nome não deve conter mais do que 255
                      caracteres</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-12">
                <div class="tagus-form-group">
                  <label class="d-block mb-12 fw-semibold gray-color"
                    >Nome do Pai <span>*</span></label
                  >
                  <mat-form-field>
                    <i class="ri-user-3-line"></i>
                    <mat-label>Insira o nome</mat-label>
                    <input
                      matInput
                      type="text"
                      formControlName="fatherName"
                      id="fatherName"
                      style="text-transform: uppercase"
                    />
                    <button mat-icon-button matSuffix type="button" (click)="copyToClipboard(professionalForm.get('fatherName')?.value, 'Nome do Pai')">
                      <mat-icon>content_copy</mat-icon>
                    </button>
                    <mat-error
                      *ngIf="hasErrorProfessional('fatherName', 'required')"
                      >O nome do Pai é obrigatório</mat-error
                    >
                    <mat-error
                      *ngIf="hasErrorProfessional('fatherName', 'minlength')"
                      >O nome deve ter no mínimo 3 caracteres</mat-error
                    >
                    <mat-error
                      *ngIf="hasErrorProfessional('fatherName', 'maxlength')"
                      >O nome não deve conter mais do que 255
                      caracteres</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-12">
                <div class="tagus-form-group">
                  <label class="d-block mb-12 fw-semibold gray-color"
                    >Nome da Mãe<span>*</span></label
                  >
                  <mat-form-field>
                    <i class="ri-user-3-line"></i>
                    <mat-label>Insira o nome da Mãe</mat-label>
                    <input
                      matInput
                      type="text"
                      formControlName="motherName"
                      id="motherName"
                      style="text-transform: uppercase"
                    />
                    <button mat-icon-button matSuffix type="button" (click)="copyToClipboard(professionalForm.get('motherName')?.value, 'Nome da Mãe')">
                      <mat-icon>content_copy</mat-icon>
                    </button>
                    <mat-error
                      *ngIf="hasErrorProfessional('motherName', 'required')"
                      >O nome da Mãe é obrigatório</mat-error
                    >
                    <mat-error
                      *ngIf="hasErrorProfessional('motherName', 'minlength')"
                      >O nome deve ter no mínimo 3 caracteres</mat-error
                    >
                    <mat-error
                      *ngIf="hasErrorProfessional('motherName', 'maxlength')"
                      >O nome não deve conter mais do que 255
                      caracteres</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-12">
                <div class="tagus-form-group">
                  <label class="d-block mb-12 fw-semibold gray-color"
                    >CPF <span>*</span></label
                  >
                  <mat-form-field appearance="fill">
                    <i class="ri-file-text-line"></i>
                    <mat-label>Insira o CPF</mat-label>
                    <input
                      matInput
                      type="text"
                      formControlName="document"
                      id="document"
                      mask="CPF_CNPJ"
                    />
                    <button mat-icon-button matSuffix type="button" (click)="copyToClipboard(professionalForm.get('document')?.value, 'CPF')">
                      <mat-icon>content_copy</mat-icon>
                    </button>
                    <mat-error
                      *ngIf="hasErrorProfessional('document', 'required')"
                      >O CPF é obrigatório</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-12">
                <div class="tagus-form-group">
                  <label class="d-block mb-12 fw-semibold gray-color"
                    >E-mail <span>*</span></label
                  >
                  <mat-form-field appearance="fill">
                    <i class="ri-mail-line"></i>
                    <mat-label>Insira o e-mail</mat-label>
                    <input
                      matInput
                      type="email"
                      formControlName="email"
                      id="email"
                    />
                    <button mat-icon-button matSuffix type="button" (click)="copyToClipboard(professionalForm.get('email')?.value, 'E-mail')">
                      <mat-icon>content_copy</mat-icon>
                    </button>
                    <mat-error *ngIf="hasErrorProfessional('email', 'required')"
                      >Email é obrigatório</mat-error
                    >
                    <mat-error
                      *ngIf="hasErrorProfessional('email', 'minlength')"
                      >Email deve ter no mínimo 3 caracteres</mat-error
                    >
                    <mat-error
                      *ngIf="hasErrorProfessional('email', 'maxlength')"
                      >Email não deve conter mais do que 80
                      caracteres</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-12">
                <div class="tagus-form-group">
                  <label class="d-block mb-12 fw-semibold gray-color"
                    >Função/Cargo <span>*</span></label
                  >
                  <mat-form-field appearance="fill">
                    <i class="ri-list-check"></i>
                    <mat-label>Função/Cargo</mat-label>
                    <mat-select formControlName="type">
                      <mat-option value="DOCTOR">Médico(a)</mat-option>
                      <mat-option value="NURSE">Enfermeiro(a)</mat-option>
                    </mat-select>
                    <mat-error *ngIf="hasErrorProfessional('type', 'required')"
                      >Função/Cargo é obrigatório</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-4 col-md-4 col-sm-4">
                  <div class="tagus-form-group">
                    <label class="d-block mb-12 fw-semibold gray-color"
                      >Gênero <span>*</span></label
                    >
                    <mat-form-field appearance="fill">
                      <i class="ri-group-line"></i>
                      <mat-label>Gênero</mat-label>
                      <mat-select formControlName="genre" id="genre">
                        <mat-option value="male">Masculino</mat-option>
                        <mat-option value="female">Feminino</mat-option>
                        <mat-option value="others">Outros</mat-option>
                      </mat-select>
                      <mat-error
                        *ngIf="hasErrorProfessional('genre', 'required')"
                        >Gênero é obrigatório</mat-error
                      >
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12">
                  <div class="tagus-form-group">
                    <label class="d-block mb-12 fw-semibold gray-color"
                      >Estado Civil <span>*</span></label
                    >
                    <mat-form-field appearance="fill">
                      <i class="ri-list-check"></i>
                      <mat-label>Estado civil</mat-label>
                      <mat-select formControlName="civilStatus">
                        <mat-option value="single">Solteiro(a)</mat-option>
                        <mat-option value="married">Casado(a)</mat-option>
                        <mat-option value="engaged">Noivo(a)</mat-option>
                        <mat-option value="divorced">Divorciado(a)</mat-option>
                        <mat-option value="widowed">Viúvo(a)</mat-option>
                        <mat-option value="common-law-marriage"
                          >União estável</mat-option
                        >
                      </mat-select>
                      <mat-error
                        *ngIf="hasErrorProfessional('civilStatus', 'required')"
                        >Estado civil é obrigatório</mat-error
                      >
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12">
                  <div class="tagus-form-group">
                    <label class="d-block mb-12 fw-semibold gray-color"
                      >Data de Nascimento <span>*</span></label
                    >
                    <mat-form-field appearance="fill">
                      <i class="ri-calendar-line"></i>
                      <mat-label>Data de Nascimento</mat-label>
                      <input
                        matInput
                        type="text"
                        formControlName="birthdate"
                        id="birthdate"
                        mask="00/00/0000"
                      />
                      <button mat-icon-button matSuffix type="button" (click)="copyToClipboard(professionalForm.get('birthdate')?.value, 'Data de Nascimento')">
                        <mat-icon>content_copy</mat-icon>
                      </button>
                      <mat-error
                        *ngIf="hasErrorProfessional('birthdate', 'required')"
                        >Data de Nascimento é obrigatório</mat-error
                      >
                    </mat-form-field>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-3 col-md-6 col-sm-12">
                  <div class="tagus-form-group">
                    <label class="d-block mb-12 fw-semibold gray-color"
                      >Nº Identidade <span>*</span></label
                    >
                    <mat-form-field appearance="fill">
                      <i class="ri-article-line"></i>
                      <mat-label>Insira nº da identidade</mat-label>
                      <input
                        matInput
                        type="text"
                        formControlName="identity"
                        id="identity"
                      />
                      <button mat-icon-button matSuffix type="button" (click)="copyToClipboard(professionalForm.get('identity')?.value, 'Nº Identidade')">
                        <mat-icon>content_copy</mat-icon>
                      </button>
                      <mat-error
                        *ngIf="hasErrorProfessional('identity', 'required')"
                        >Nº da identidade é obrigatório</mat-error
                      >
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-12">
                  <div class="tagus-form-group">
                    <label class="d-block mb-12 fw-semibold gray-color"
                      >Órgão emissor <span>*</span></label
                    >
                    <mat-form-field appearance="fill">
                      <i class="ri-user-4-line"></i>
                      <mat-label>Órgão emissor</mat-label>
                      <input
                        matInput
                        type="text"
                        formControlName="identityAgency"
                        id="identityAgency"
                        style="text-transform: uppercase"
                      />
                      <button mat-icon-button matSuffix type="button" (click)="copyToClipboard(professionalForm.get('identityAgency')?.value, 'Órgão emissor')">
                        <mat-icon>content_copy</mat-icon>
                      </button>
                      <mat-error
                        *ngIf="
                          hasErrorProfessional('identityAgency', 'required')
                        "
                        >Órgão emissor é obrigatório</mat-error
                      >
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-12">
                  <div class="tagus-form-group">
                    <label class="d-block mb-12 fw-semibold gray-color"
                      >Data de emissão <span>*</span></label
                    >
                    <mat-form-field appearance="fill">
                      <i class="ri-calendar-line"></i>
                      <mat-label>Data de emissão</mat-label>
                      <input
                        matInput
                        type="text"
                        formControlName="identityDate"
                        id="identityDate"
                        mask="00/00/0000"
                        style="text-transform: uppercase"
                      />
                      <button mat-icon-button matSuffix type="button" (click)="copyToClipboard(professionalForm.get('identityDate')?.value, 'Data de emissão')">
                        <mat-icon>content_copy</mat-icon>
                      </button>
                      <mat-error
                        *ngIf="hasErrorProfessional('identityDate', 'required')"
                        >Data de emissão é obrigatório</mat-error
                      >
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-3">
                  <div class="tagus-form-group">
                    <label class="d-block mb-12 fw-semibold gray-color"
                      >UF Emissão <span>*</span></label
                    >
                    <mat-form-field appearance="fill">
                      <i class="ri-list-check"></i>
                      <mat-label>UF</mat-label>
                      <mat-select formControlName="identityUf">
                        <mat-option
                          *ngFor="let state of states"
                          [value]="state.value"
                          >{{ state.name }}</mat-option
                        >
                      </mat-select>
                      <mat-error
                        *ngIf="hasErrorProfessional('identityUf', 'required')"
                        >UF Emissão é obrigatório</mat-error
                      >
                    </mat-form-field>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-12">
                  <div class="tagus-form-group">
                    <label class="d-block mb-3 fw-semibold gray-color"
                      >Número do SUS <span>*</span></label
                    >
                    <mat-form-field appearance="fill">
                      <i class="ri-file-list-3-line"></i>
                      <mat-label>Insira o número do SUS</mat-label>
                      <input
                        matInput
                        type="text"
                        formControlName="numberHealth"
                        id="numberHealth"
                      />
                      <button mat-icon-button matSuffix type="button" (click)="copyToClipboard(professionalForm.get('numberHealth')?.value, 'Número do SUS')">
                        <mat-icon>content_copy</mat-icon>
                      </button>
                      <mat-error
                        *ngIf="hasErrorProfessional('numberHealth', 'required')"
                        >Número do SUS é obrigatório</mat-error
                      >
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12">
                  <div class="tagus-form-group">
                    <label class="d-block mb-3 fw-semibold gray-color"
                      >Tipo sanguíneo <span>*</span></label
                    >
                    <mat-form-field appearance="fill">
                      <i class="ri-drop-line"></i>
                      <mat-label>Selecione o tipo sanguíneo</mat-label>
                      <mat-select formControlName="bloodType">
                        <mat-option value="A+">A+</mat-option>
                        <mat-option value="A-">A-</mat-option>
                        <mat-option value="B+">B+</mat-option>
                        <mat-option value="B-">B-</mat-option>
                        <mat-option value="AB+">AB+</mat-option>
                        <mat-option value="AB-">AB-</mat-option>
                        <mat-option value="O+">O+</mat-option>
                        <mat-option value="O-">O-</mat-option>
                      </mat-select>
                      <mat-error
                        *ngIf="hasErrorProfessional('bloodType', 'required')"
                        >Tipo sanguíneo é obrigatório</mat-error
                      >
                    </mat-form-field>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-4 col-md-4 col-sm-12">
                  <div class="tagus-form-group">
                    <label class="d-block mb-3 fw-semibold gray-color"
                      >Vínculo Trabalhista</label
                    >
                    <mat-form-field appearance="fill">
                      <i class="ri-briefcase-line"></i>
                      <mat-label>Selecione o vínculo</mat-label>
                      <mat-select formControlName="employmentType">
                        <mat-option *ngFor="let opt of employmentTypeOptions" [value]="opt.value">{{ opt.label }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12">
                  <div class="tagus-form-group">
                    <label class="d-block mb-3 fw-semibold gray-color"
                      >Status de Atividade</label
                    >
                    <mat-form-field appearance="fill">
                      <i class="ri-toggle-line"></i>
                      <mat-label>Selecione o status</mat-label>
                      <mat-select formControlName="isActive">
                        <mat-option [value]="true">Ativo</mat-option>
                        <mat-option [value]="false">Inativo</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12">
                  <div class="tagus-form-group">
                    <label class="d-block mb-3 fw-semibold gray-color"
                      >Status do Cadastro</label
                    >
                    <mat-form-field appearance="fill">
                      <i class="ri-shield-check-line"></i>
                      <mat-label>Selecione o status</mat-label>
                      <mat-select formControlName="status">
                        <mat-option *ngFor="let opt of statusOptions" [value]="opt.value">{{ opt.label }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-6">
                  <div class="tagus-form-group">
                    <label class="d-block mb-12 fw-semibold gray-color"
                      >Telefone</label
                    >
                    <mat-form-field appearance="fill">
                      <i class="ri-phone-line"></i>
                      <mat-label>Insira o número de telefone</mat-label>
                      <input
                        matInput
                        type="text"
                        formControlName="phone"
                        mask="(+00) 00 0 0000-0000"
                        style="text-transform: uppercase"
                      />
                      <button mat-icon-button matSuffix type="button" (click)="copyToClipboard(professionalForm.get('phone')?.value, 'Telefone')">
                        <mat-icon>content_copy</mat-icon>
                      </button>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6">
                  <div class="tagus-form-group">
                    <label class="d-block mb-12 fw-semibold gray-color"
                      >Celular <span>*</span></label
                    >
                    <mat-form-field appearance="fill">
                      <i class="ri-smartphone-line"></i>
                      <mat-label>Insira o número do celular</mat-label>
                      <input
                        matInput
                        type="text"
                        formControlName="cellphone"
                        mask="+00 (00) 0 0000-0000"
                      />
                      <button mat-icon-button matSuffix type="button" (click)="copyToClipboard(professionalForm.get('cellphone')?.value, 'Celular')">
                        <mat-icon>content_copy</mat-icon>
                      </button>
                    </mat-form-field>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-4 col-md-6 col-sm-12">
                  <div class="tagus-form-group">
                    <label class="d-block mb-3 fw-semibold gray-color"
                      >Nacionalidade <span>*</span></label
                    >
                    <mat-form-field appearance="fill">
                      <i class="ri-list-check"></i>
                      <mat-label>Nacionalidade</mat-label>
                      <mat-select formControlName="nationality">
                        <mat-option
                          *ngFor="let nationality of nationalities"
                          [value]="nationality"
                          >{{ nationality }}</mat-option
                        >
                      </mat-select>
                      <mat-error
                        *ngIf="hasErrorProfessional('nationality', 'required')"
                        >Nacionalidade é obrigatório</mat-error
                      >
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12">
                  <div class="tagus-form-group">
                    <label class="d-block mb-3 fw-semibold gray-color"
                      >Naturalidade <span>*</span></label
                    >
                    <mat-form-field appearance="fill">
                      <i class="ri-list-check"></i>
                      <mat-label>Naturalidade</mat-label>
                      <mat-select formControlName="citizenship">
                        <mat-option
                          *ngFor="let state of states"
                          [value]="state.value"
                          >{{ state.name }}</mat-option
                        >
                      </mat-select>
                      <mat-error
                        *ngIf="hasErrorProfessional('citizenship', 'required')"
                        >Naturalidade é obrigatório</mat-error
                      >
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12">
                  <div class="tagus-form-group">
                    <label class="d-block mb-3 fw-semibold gray-color"
                      >Cidade de Nascimento <span>*</span></label
                    >
                    <mat-form-field appearance="fill">
                      <i class="ri-map-2-line"></i>
                      <mat-label>Cidade de nascimento</mat-label>
                      <input
                        matInput
                        type="text"
                        formControlName="birthplace"
                        id="birthplace"
                        style="text-transform: uppercase"
                      />
                      <button mat-icon-button matSuffix type="button" (click)="copyToClipboard(professionalForm.get('birthplace')?.value, 'Cidade de Nascimento')">
                        <mat-icon>content_copy</mat-icon>
                      </button>
                      <mat-error
                        *ngIf="hasErrorProfessional('birthplace', 'required')"
                        >Cidade de nascimento é obrigatório</mat-error
                      >
                    </mat-form-field>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-3 col-md-6 col-sm-12">
                  <div class="tagus-form-group">
                    <label class="d-block mb-3 fw-semibold gray-color"
                      >Título de eleitor <span>*</span></label
                    >
                    <mat-form-field appearance="fill">
                      <i class="ri-map-2-line"></i>
                      <mat-label>Insira o Título de eleitor</mat-label>
                      <input
                        matInput
                        type="text"
                        formControlName="voterRegistration"
                        id="voterRegistration"
                      />
                      <button mat-icon-button matSuffix type="button" (click)="copyToClipboard(professionalForm.get('voterRegistration')?.value, 'Título de eleitor')">
                        <mat-icon>content_copy</mat-icon>
                      </button>
                      <mat-error
                        *ngIf="
                          hasErrorProfessional('voterRegistration', 'required')
                        "
                        >Título de eleitor é obrigatório</mat-error
                      >
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-12">
                  <div class="tagus-form-group">
                    <label class="d-block mb-3 fw-semibold gray-color"
                      >Nº do PIS <span>*</span></label
                    >
                    <mat-form-field appearance="fill">
                      <i class="ri-map-2-line"></i>
                      <mat-label>Número do PIS</mat-label>
                      <input
                        matInput
                        type="number"
                        formControlName="pis"
                        id="pis"
                      />
                      <button mat-icon-button matSuffix type="button" (click)="copyToClipboard(professionalForm.get('pis')?.value, 'Nº do PIS')">
                        <mat-icon>content_copy</mat-icon>
                      </button>
                      <mat-error *ngIf="hasErrorProfessional('pis', 'required')"
                        >Nº do PIS é obrigatório</mat-error
                      >
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-12">
                  <div class="tagus-form-group">
                    <label class="d-block mb-3 fw-semibold gray-color"
                      >Nº Licença <span>*</span></label
                    >
                    <mat-form-field appearance="fill">
                      <i class="ri-file-list-3-line"></i>
                      <mat-label>Licença (CRM/ENF/Outro)</mat-label>
                      <input
                        matInput
                        type="text"
                        formControlName="licenseNumber"
                        id="licenseNumber"
                      />
                      <button mat-icon-button matSuffix type="button" (click)="copyToClipboard(professionalForm.get('licenseNumber')?.value, 'Nº Licença')">
                        <mat-icon>content_copy</mat-icon>
                      </button>
                      <mat-error
                        *ngIf="
                          hasErrorProfessional('licenseNumber', 'required')
                        "
                        >Nº Licença é obrigatório</mat-error
                      >
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-12">
                  <div class="tagus-form-group">
                    <label class="d-block mb-3 fw-semibold gray-color"
                      >Nº RQE
                    </label>
                    <mat-form-field appearance="fill">
                      <i class="ri-article-fill"></i>
                      <mat-label>Insira o nº do RQE</mat-label>
                      <input
                        matInput
                        type="text"
                        formControlName="rqe"
                        id="rqe"
                      />
                      <button mat-icon-button matSuffix type="button" (click)="copyToClipboard(professionalForm.get('rqe')?.value, 'Nº RQE')">
                        <mat-icon>content_copy</mat-icon>
                      </button>
                    </mat-form-field>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-4 col-md-6 col-sm-12">
                  <div class="tagus-form-group">
                    <label class="d-block mb-12 fw-semibold gray-color"
                      >Principal especialidade médica <span>*</span></label
                    >
                    <mat-form-field appearance="fill">
                      <mat-label>Especialidade</mat-label>
                      <i class="ri-list-check"></i>
                      <mat-select formControlName="majorMedicalSpecialty">
                        <mat-option
                          *ngFor="let specialty of specialties"
                          [value]="specialty._id"
                          >{{ specialty.name }}</mat-option
                        >
                      </mat-select>
                      <mat-error
                        *ngIf="
                          hasErrorProfessional(
                            'majorMedicalSpecialty',
                            'required'
                          )
                        "
                        >Especialidade principal é obrigatório</mat-error
                      >
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12">
                  <div class="tagus-form-group">
                    <label class="d-block mb-12 fw-semibold gray-color"
                      >Outras especialidades</label
                    >
                    <mat-form-field appearance="fill">
                      <mat-label>Outras especialidade</mat-label>
                      <i class="ri-list-check"></i>
                      <mat-select formControlName="otherSpecialties">
                        <mat-option
                          *ngFor="let specialty of specialties"
                          [value]="specialty._id"
                          >{{ specialty.name }}</mat-option
                        >
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12">
                  <div class="tagus-form-group">
                    <label class="d-block mb-12 fw-semibold gray-color"
                      >Àrea de atuação <span>*</span></label
                    >
                    <mat-form-field appearance="fill">
                      <mat-label>Àrea de atuação</mat-label>
                      <i class="ri-list-check"></i>
                      <mat-select formControlName="occupationArea">
                        <mat-option
                          *ngFor="let area of occupationAreas"
                          [value]="area._id"
                          >{{ area.name }}</mat-option
                        >
                      </mat-select>
                      <mat-error
                        *ngIf="
                          hasErrorProfessional('occupationArea', 'required')
                        "
                        >Área de atuação é obrigatório</mat-error
                      >
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-5">
              <button mat-flat-button class="tagus" type="submit">
                Atualizar
              </button>
            </div>
          </form>
        </div>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="mr-1">import_contacts</mat-icon>
          Endereço
        </ng-template>
        <br />
        <div fxFlex="100%" class="row">
          <form [formGroup]="addressForm" (submit)="onAddressSubmit()">
            <div class="row">
              <div class="col-lg-6 col-md-6 col-sm-6">
                <div class="tagus-form-group">
                  <label class="d-block mb-12 fw-semibold gray-color"
                    >CEP <span>*</span></label
                  >
                  <mat-form-field appearance="fill">
                    <i class="ri-file-code-line"></i>
                    <mat-label>Insira o CEP</mat-label>
                    <input
                      matInput
                      type="text"
                      formControlName="zipcode"
                      id="zipcode"
                      mask="00000-000"
                    />
                    <button mat-icon-button matSuffix type="button" (click)="copyToClipboard(addressForm.get('zipcode')?.value, 'CEP')">
                      <mat-icon>content_copy</mat-icon>
                    </button>
                    <mat-error *ngIf="hasErrorAddress('zipcode', 'required')"
                      >O CEP é obrigatório</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6">
                <div class="tagus-form-group">
                  <label class="d-block mb-12 fw-semibold gray-color"
                    >Logradouro <span>*</span></label
                  >
                  <mat-form-field appearance="fill">
                    <i class="ri-navigation-line"></i>
                    <mat-label>Insira o logradouro</mat-label>
                    <input
                      matInput
                      type="text"
                      formControlName="street"
                      id="street"
                      style="text-transform: uppercase"
                    />
                    <button mat-icon-button matSuffix type="button" (click)="copyToClipboard(addressForm.get('street')?.value, 'Logradouro')">
                      <mat-icon>content_copy</mat-icon>
                    </button>
                    <mat-error *ngIf="hasErrorAddress('street', 'required')"
                      >O CEP é obrigatório</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6">
                <div class="tagus-form-group">
                  <label class="d-block mb-12 fw-semibold gray-color"
                    >Número <span>*</span></label
                  >
                  <mat-form-field appearance="fill">
                    <i class="ri-home-5-line"></i>
                    <mat-label>Insira o número</mat-label>
                    <input
                      matInput
                      type="text"
                      formControlName="number"
                      id="number"
                    />
                    <button mat-icon-button matSuffix type="button" (click)="copyToClipboard(addressForm.get('number')?.value, 'Número')">
                      <mat-icon>content_copy</mat-icon>
                    </button>
                    <mat-error *ngIf="hasErrorAddress('number', 'required')"
                      >O número é obrigatório</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6">
                <div class="tagus-form-group">
                  <label class="d-block mb-12 fw-semibold gray-color"
                    >Bairro <span>*</span></label
                  >
                  <mat-form-field appearance="fill">
                    <i class="ri-community-line"></i>
                    <mat-label>Insira o bairro</mat-label>
                    <input
                      matInput
                      type="text"
                      formControlName="neighborhood"
                      id="neighborhood"
                      style="text-transform: uppercase"
                    />
                    <button mat-icon-button matSuffix type="button" (click)="copyToClipboard(addressForm.get('neighborhood')?.value, 'Bairro')">
                      <mat-icon>content_copy</mat-icon>
                    </button>
                    <mat-error
                      *ngIf="hasErrorAddress('neighborhood', 'required')"
                      >O bairro é obrigatório</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12">
                <div class="tagus-form-group">
                  <label class="d-block mb-12 fw-semibold gray-color"
                    >Complemento</label
                  >
                  <mat-form-field appearance="fill">
                    <i class="ri-road-map-line"></i>
                    <mat-label>Insira o complemento</mat-label>
                    <input matInput formControlName="complement" />
                    <button mat-icon-button matSuffix type="button" (click)="copyToClipboard(addressForm.get('complement')?.value, 'Complemento')">
                      <mat-icon>content_copy</mat-icon>
                    </button>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6">
                <div class="tagus-form-group">
                  <label class="d-block mb-12 fw-semibold gray-color"
                    >Cidade <span>*</span></label
                  >
                  <mat-form-field appearance="fill">
                    <i class="ri-map-pin-line"></i>
                    <mat-label>Insira a cidade</mat-label>
                    <input
                      matInput
                      type="text"
                      formControlName="city"
                      id="city"
                      style="text-transform: uppercase"
                    />
                    <button mat-icon-button matSuffix type="button" (click)="copyToClipboard(addressForm.get('city')?.value, 'Cidade')">
                      <mat-icon>content_copy</mat-icon>
                    </button>
                    <mat-error *ngIf="hasErrorAddress('city', 'required')"
                      >A cidade é obrigatório</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6">
                <div class="tagus-form-group">
                  <label class="d-block mb-12 fw-semibold gray-color"
                    >Estado <span>*</span></label
                  >
                  <mat-form-field appearance="fill">
                    <i class="ri-map-2-line"></i>
                    <mat-label>Insira o estado</mat-label>
                    <input
                      matInput
                      type="text"
                      formControlName="state"
                      id="state"
                      style="text-transform: uppercase"
                    />
                    <button mat-icon-button matSuffix type="button" (click)="copyToClipboard(addressForm.get('state')?.value, 'Estado')">
                      <mat-icon>content_copy</mat-icon>
                    </button>
                    <mat-error *ngIf="hasErrorAddress('state', 'required')"
                      >O estado é obrigatório</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="mt-5">
              <button
                mat-flat-button
                class="tagus"
                [disabled]="!addressForm.valid"
              >
                Atualizar
              </button>
            </div>
          </form>
        </div>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="mr-1">account_balance</mat-icon>
          Dados Bancários
        </ng-template>
        <br />
        <div fxFlex="100%" class="row">
          <form [formGroup]="bankForm" (submit)="onBankSubmit()">
            <div class="row">
              <div class="col-lg-6 col-md-6 col-sm-6">
                <div class="tagus-form-group">
                  <label class="d-block mb-12 fw-semibold gray-color"
                    >Banco <span>*</span></label
                  >
                  <mat-form-field appearance="fill">
                    <i class="ri-bank-line"></i>
                    <mat-label>Nome do banco</mat-label>
                    <input
                      matInput
                      type="text"
                      formControlName="bank"
                      id="bank"
                      style="text-transform: uppercase"
                    />
                    <button mat-icon-button matSuffix type="button" (click)="copyToClipboard(bankForm.get('bank')?.value, 'Banco')">
                      <mat-icon>content_copy</mat-icon>
                    </button>
                    <mat-error *ngIf="hasErrorBank('bank', 'required')"
                      >O nome do banco é obrigatório</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6">
                <div class="tagus-form-group">
                  <label class="d-block mb-12 fw-semibold gray-color"
                    >Agência <span>*</span></label
                  >
                  <mat-form-field appearance="fill">
                    <i class="ri-bank-card-line"></i>
                    <mat-label>Insira o nº da agência</mat-label>
                    <input
                      matInput
                      type="text"
                      formControlName="agency"
                      id="agency"
                    />
                    <button mat-icon-button matSuffix type="button" (click)="copyToClipboard(bankForm.get('agency')?.value, 'Agência')">
                      <mat-icon>content_copy</mat-icon>
                    </button>
                    <mat-error *ngIf="hasErrorBank('agency', 'required')"
                      >A agência é obrigatório</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6">
                <div class="tagus-form-group">
                  <label class="d-block mb-12 fw-semibold gray-color"
                    >Conta <span>*</span></label
                  >
                  <mat-form-field appearance="fill">
                    <i class="ri-account-box-line"></i>
                    <mat-label>Nº da conta</mat-label>
                    <input
                      matInput
                      type="text"
                      formControlName="account"
                      id="account"
                      (input)="formatAccountNumber($event)"
                      placeholder="ex: 123456-7"
                    />
                    <button mat-icon-button matSuffix type="button" (click)="copyToClipboard(bankForm.get('account')?.value, 'Conta')">
                      <mat-icon>content_copy</mat-icon>
                    </button>
                    <mat-error *ngIf="hasErrorBank('account', 'required')"
                      >O número da conta é obrigatório</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6">
                <div class="tagus-form-group">
                  <label class="d-block mb-12 fw-semibold gray-color"
                    >Tipo de Pessoa <span>*</span></label
                  >
                  <mat-form-field appearance="fill">
                    <i class="ri-user-line"></i>
                    <mat-label>Selecione o tipo</mat-label>
                    <mat-select formControlName="accountType" id="accountType">
                      <mat-option value="">Selecione uma opção</mat-option>
                      <mat-option value="PF">Pessoa Física (PF)</mat-option>
                      <mat-option value="PJ">Pessoa Jurídica (PJ)</mat-option>
                    </mat-select>
                    <mat-error *ngIf="hasErrorBank('accountType', 'required')"
                      >O tipo de pessoa é obrigatório</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6">
                <div class="tagus-form-group">
                  <label class="d-block mb-12 fw-semibold gray-color"
                    >Tipo da Conta <span>*</span></label
                  >
                  <mat-form-field appearance="fill">
                    <i class="ri-list-check-2"></i>
                    <mat-label>Insira o tipo da conta</mat-label>
                    <input
                      matInput
                      type="text"
                      formControlName="typeAccount"
                      id="typeAccount"
                    />
                    <button mat-icon-button matSuffix type="button" (click)="copyToClipboard(bankForm.get('typeAccount')?.value, 'Tipo da Conta')">
                      <mat-icon>content_copy</mat-icon>
                    </button>
                    <mat-error *ngIf="hasErrorBank('typeAccount', 'required')"
                      >O tipo da conta é obrigatório</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12">
                <div class="tagus-form-group">
                  <label class="d-block mb-12 fw-semibold gray-color"
                    >Chave PIX <span>*</span></label
                  >
                  <mat-form-field appearance="fill">
                    <i class="ri-shield-keyhole-line"></i>
                    <mat-label>Insira a chave PIX</mat-label>
                    <input
                      matInput
                      type="text"
                      formControlName="keyPix"
                      id="keyPix"
                    />
                    <button mat-icon-button matSuffix type="button" (click)="copyToClipboard(bankForm.get('keyPix')?.value, 'Chave PIX')">
                      <mat-icon>content_copy</mat-icon>
                    </button>
                    <mat-error *ngIf="hasErrorBank('keyPix', 'required')"
                      >A chave pix é obrigatório</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="mt-5">
              <button
                mat-flat-button
                class="tagus"
                [disabled]="!bankForm.valid"
              >
                Atualizar
              </button>
            </div>
          </form>
        </div>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label id="documents">
          <mat-icon class="mr-1">folder_open</mat-icon>
          Documentos
        </ng-template>
        <br />
        <div fxFlex="100%" class="col">
          <div class="docs-toolbar mb-25">
            <div
              fxLayout="row"
              fxLayoutAlign="space-between center"
              fxLayoutGap="14px"
              fxLayout.xs="column"
              fxLayoutAlign.xs="start stretch"
            >
              <mat-form-field appearance="fill" class="docs-search">
                <mat-icon matPrefix>search</mat-icon>
                <mat-label>Buscar documentos</mat-label>
                <input
                  matInput
                  [ngModelOptions]="{ standalone: true }"
                  [(ngModel)]="fileSearch"
                  placeholder="Nome, descrição ou tipo"
                />
              </mat-form-field>

              <div
                class="docs-actions"
                fxLayout="row"
                fxLayoutGap="10px"
                fxLayoutAlign="end center"
              >
                <mat-chip
                  class="filter-chip"
                  [class.active]="fileStatusFilter === 'ALL'"
                  (click)="fileStatusFilter = 'ALL'"
                  disableRipple
                >
                  Todos
                </mat-chip>
                <mat-chip
                  class="filter-chip"
                  [class.active]="fileStatusFilter === 'APPROVED'"
                  (click)="fileStatusFilter = 'APPROVED'"
                  disableRipple
                >
                  Aprovados
                </mat-chip>
                <mat-chip
                  class="filter-chip"
                  [class.active]="fileStatusFilter === 'PENDING'"
                  (click)="fileStatusFilter = 'PENDING'"
                  disableRipple
                >
                  Pendentes
                </mat-chip>
                <mat-chip
                  class="filter-chip"
                  [class.active]="fileStatusFilter === 'PENDING_UPLOAD'"
                  (click)="fileStatusFilter = 'PENDING_UPLOAD'"
                  disableRipple
                >
                  Aguardando envio
                </mat-chip>
                <mat-chip
                  class="filter-chip"
                  [class.active]="fileStatusFilter === 'REJECTED'"
                  (click)="fileStatusFilter = 'REJECTED'"
                  disableRipple
                >
                  Rejeitados
                </mat-chip>

                <button
                  mat-raised-button
                  class="tagus"
                  [disabled]="!hasApprovedDocuments()"
                  (click)="downloadAllApprovedDocuments()"
                >
                  <mat-icon>cloud_download</mat-icon>
                  Baixar aprovados
                </button>
              </div>
            </div>
          </div>

          <div class="docs-empty" *ngIf="!professionalData?.files?.length">
            <div class="docs-empty__icon">
              <i class="ri-folder-open-line"></i>
            </div>
            <div class="docs-empty__text">
              <h6 class="mb-0">Nenhum documento encontrado</h6>
              <p class="mb-0">
                Quando o profissional enviar arquivos, eles aparecerão aqui para
                validação.
              </p>
            </div>
          </div>

          <div class="docs-grid" *ngIf="professionalData?.files?.length">
            <mat-card
              class="tagus-card doc-card"
              *ngFor="let document of filteredFiles"
            >
              <mat-card-content>
                <div class="doc-card__top">
                  <div class="doc-card__file">
                    <div class="doc-card__icon">
                      <i [class]="fileIconFor(document.mimetype)"></i>
                    </div>
                    <div class="doc-card__meta">
                      <div class="doc-card__name" [matTooltip]="document.name">
                        {{ document.name }}
                      </div>
                      <div class="doc-card__desc" *ngIf="document.description">
                        {{ document.description }}
                      </div>
                      <div class="doc-card__sub">
                        <span class="size">{{
                          convertSize(document.size)
                        }}</span>
                        <span class="dot">•</span>
                        <span class="type">{{ document.mimetype }}</span>
                      </div>
                    </div>
                  </div>

                  <mat-chip
                    class="doc-status"
                    [class.is-approved]="document.status === 'APPROVED'"
                    [class.is-rejected]="document.status === 'REJECTED'"
                    [class.is-pending-upload]="
                      document.status === 'PENDING_UPLOAD'
                    "
                    [class.is-pending]="document.status === 'PENDING'"
                    disableRipple
                  >
                    {{ getNameStatus(document.status) }}
                  </mat-chip>
                </div>

                <div class="doc-card__actions">
                  <button
                    mat-icon-button
                    class="tagus"
                    matTooltip="Visualizar"
                    (click)="viewFileDialog(document._id, document.mimetype)"
                  >
                    <mat-icon>visibility</mat-icon>
                  </button>
                  <button
                    mat-icon-button
                    class="tagus"
                    matTooltip="Baixar"
                    (click)="
                      downloadFile(
                        document._id,
                        document.mimetype,
                        document.name
                      )
                    "
                  >
                    <mat-icon>download</mat-icon>
                  </button>
                  <button
                    mat-icon-button
                    class="tagus"
                    matTooltip="Aprovar"
                    (click)="checkFile(document._id, 'APPROVED')"
                  >
                    <mat-icon>check_circle</mat-icon>
                  </button>
                  <button
                    mat-icon-button
                    class="tagus"
                    matTooltip="Rejeitar"
                    (click)="checkFile(document._id, 'REJECTED')"
                  >
                    <mat-icon>cancel</mat-icon>
                  </button>
                  <button
                    mat-icon-button
                    class="tagus"
                    matTooltip="Editar Arquivo"
                    (click)="
                      openDialog(
                        document._id,
                        document.fieldname,
                        document.description,
                        document.name
                      )
                    "
                  >
                    <mat-icon>edit</mat-icon>
                  </button>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </mat-card-content>
</mat-card>
